import { Reveal } from './Reveal';

const COLUMNS = [
  { heading: 'Products', links: ['Bulk SMS', 'Voice', 'Whatsapp', 'Airtime & Data', 'USSD'] },
  { heading: 'Resources', links: ['Documentation', 'Guides', 'Help Center'] },
  { heading: 'Company', links: ['About Us', 'Careers', 'Contact Us', 'Privacy Policy', 'Terms of Service'] },
];

const linkStyle = {
  fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#fff', textDecoration: 'none', opacity: 0.85,
};

export function Footer() {
  return (
    <footer style={{ background: '#0c2147' }}>
      <Reveal y={20}>
      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '56px 24px 32px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 40, marginBottom: 40 }}>
          <div style={{ flex: '1 1 260px', maxWidth: 300 }}>
            <img src="/landing/logo.png" alt="Sleengshort" width={140} height={40} style={{ objectFit: 'contain', width: 'auto', height: 40, filter: 'brightness(0) invert(1)', marginBottom: 24 }} />
            <p style={{ margin: '0 0 16px', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#fff', opacity: 0.85, lineHeight: 1.5 }}>
              4A, Olaide Omotoro Street off CIS road, off Amore, lekki, Lagos
            </p>
            <p style={{ margin: 0, fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#fff', opacity: 0.85, lineHeight: 1.5 }}>
              71-75 Shelton street covent garden London
            </p>
          </div>

          {COLUMNS.map(col => (
            <div key={col.heading} style={{ flex: '1 1 140px' }}>
              <p style={{ margin: '0 0 16px', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#fff' }}>{col.heading}</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                {col.links.map(l => <a key={l} href="#" style={linkStyle}>{l}</a>)}
              </div>
            </div>
          ))}

          <div style={{ flex: '1 1 180px' }}>
            <p style={{ margin: '0 0 16px', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#fff' }}>Call</p>
            <p style={{ margin: '0 0 14px', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#fff', opacity: 0.85 }}>+2348114159025</p>
            <p style={{ margin: '0 0 22px', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#fff', opacity: 0.85 }}>+447944554720</p>
            <p style={{ margin: '0 0 16px', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#fff' }}>Email</p>
            <p style={{ margin: 0, fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#fff', opacity: 0.85 }}>Support@sleengshort.com</p>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <p style={{ margin: 0, fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#fff', opacity: 0.85 }}>
            © Copyright 2026 Sleengshort LTD
          </p>
          <div style={{ display: 'flex', gap: 12 }}>
            {['social-instagram.png', 'social-linkedin.png', 'social-x.png'].map(icon => (
              <a key={icon} href="#" style={{ width: 25, height: 25, position: 'relative', display: 'inline-block' }}>
                <img src={`/landing/${icon}`} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }} />
              </a>
            ))}
          </div>
        </div>
      </div>
      </Reveal>
    </footer>
  );
}
